import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormValidationDirective } from './Directives/form-validation.directive';
import { FormGroupComponent } from './Components/form-group-component/form-group-component';
import { ErrorMessageService } from './Services/error-message.service';
import { ErrorMessage } from './Models/ErrorMessage';
import { CUSTOM_ERROR_MESSAGES } from './Tokens/tokens';
export class NgBootstrapFormValidationModule {
/**
 * @param {?=} customErrorMessages
 * @return {?}
 */
static forRoot(customErrorMessages?: ErrorMessage[]): ModuleWithProviders {
    return {
      ngModule: NgBootstrapFormValidationModule,
      providers: [
        {
          provide: ErrorMessageService,
          useFactory: errorMessageServiceFactory,
          deps: [CUSTOM_ERROR_MESSAGES]
        },
        {
          provide: CUSTOM_ERROR_MESSAGES,
          useValue: customErrorMessages
        }
      ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [FormValidationDirective, FormGroupComponent],
  imports: [CommonModule],
  providers: [ErrorMessageService],
  exports: [FormValidationDirective, FormGroupComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgBootstrapFormValidationModule_tsickle_Closure_declarations() {
/** @type {?} */
NgBootstrapFormValidationModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgBootstrapFormValidationModule.ctorParameters;
}

/**
 * @param {?=} customErrorMessages
 * @return {?}
 */
export function errorMessageServiceFactory(
  customErrorMessages?: ErrorMessage[]
) {
  return new ErrorMessageService(customErrorMessages);
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ~/ng-bootstrap-form-validation/ng-bootstrap-form-validation/src/lib/ng-bootstrap-form-validation.module.ts